import type { Authorizer } from '@owner/auth'
import type {
  NavigationGuardReturn,
  RouteLocationNormalizedGeneric,
} from 'vue-router'

import { type useAuthStore } from '@/auth/useAuthStore'
import { checkACL } from '@/utils/acl'

export const checkPermissionsV2 = (
  to: RouteLocationNormalizedGeneric,
  authStore: ReturnType<typeof useAuthStore>,
  authorizer: Authorizer
): NavigationGuardReturn => {
  if (to.meta.authZ) {
    if (!to.meta.authZ({ user: authorizer })) {
      return authStore.home
    }
  }

  // ACL check (unchanged - still separate concern)
  if (to.meta.acl) {
    const userAcl = authStore.acl
    const aclParams = Object.entries(to.meta.acl).reduce(
      (acc, [collection, routeParam]) =>
        Object.assign(acc, { [collection]: to.params[routeParam] }),
      {}
    )

    if (!checkACL(userAcl, aclParams)) {
      return authStore.home
    }
  }
}
